import { QrFieldSource } from 'editor/src/store/design/types';

/**
 * The code-set column a QR field's value depends on, if any: its own, or that of
 * the bound text it reads. A QR mirroring a bound text encodes a different value
 * on every unit just as surely as one reading the column directly.
 */
function getQrFieldVariableColumn(source: QrFieldSource, boundTextColumns: Map<number, string>): string | undefined {
  if (source.type === 'column') {
    return source.column;
  }
  if (source.type === 'element') {
    return boundTextColumns.get(source.elementId);
  }
  return undefined;
}

export default getQrFieldVariableColumn;
